import { useEffect } from 'react';
import { useIsLoggedIn } from './use-is-logged-in';
import { useLoaderData, useLocation, useNavigate } from '@remix-run/react';
import type { loader } from '~/routes/_index';

export function useForceLoginOnAllScreens(): boolean {
  const { isForceLoginOnAllScreens } = useLoaderData<typeof loader>();

  const { isLoggedIn } = useIsLoggedIn();

  const navigate = useNavigate();
  const location = useLocation();

  const locationPathname: string = location.pathname.toLowerCase();

  useEffect(() => {
    if (!isForceLoginOnAllScreens) return;

    if (isLoggedIn === null || isLoggedIn) return;

    if (locationPathname === '/login') return;

    navigate(
      `/login?redirectBack=${encodeURIComponent(
        location.pathname + location.search
      )}`
    );
  }, [isForceLoginOnAllScreens, isLoggedIn, locationPathname, navigate]);

  return isForceLoginOnAllScreens && !isLoggedIn;
}
